export default __webpack_public_path__ + "static/media/tool-change-product.d6c07b29.png";